// @flow
import React, { Component } from 'react'
import MetricsCondition from './MetricsCondition'
import type { ConditionType, OptionType } from '../types'

type Props = {|
  condition: ConditionType,
  t: Function,
  options: Array<OptionType>,
  isOnlyInfo?: boolean,
  disabled?: boolean,
  onChange?: Function
|}

export default class Condition extends Component<Props> {
  render() {
    const { condition, t, options, disabled, isOnlyInfo } = this.props

    if (condition.condition_type === 'metrics') {
      return (
        <MetricsCondition
          t={t}
          options={options}
          condition={condition}
          disabled={disabled}
          isOnlyInfo={isOnlyInfo}
          onChange={(condition) => this.conditionChanged(condition)}
        />
      )
    } else {
      return <h1>{t('unknown_condition')}</h1>
    }
  }

  conditionChanged(condition: ConditionType) {
    this.props.onChange && this.props.onChange(condition)
  }
}
